import React from "react";
import PropTypes from "prop-types";
import BaseLayout from "core/layouts/Base";

function ThreeColumn({
  className,
  style,
  leftSectionStyle,
  middleSectionStyle,
  rightSectionStyle,
  leftSection,
  middleSection,
  rightSection,
  isLeftFillSpace,
  isRightFillSpace,
  ismiddleFillSpace,
  ...props
}) {
  return (
    <BaseLayout
      className={`${className}`}
      style={style}
      {...props}
    >
      {({ Row, Column }) => (
        <>
          <Column
            isFillSpace={isLeftFillSpace}
            style={leftSectionStyle}
          >
            {leftSection}
          </Column>
          <Column
            isFillSpace={ismiddleFillSpace}
            style={middleSectionStyle}
          >
            {middleSection}
          </Column>
          <Column
            isFillSpace={isRightFillSpace}
            style={rightSectionStyle}
          >
            {rightSection}
          </Column>
        </>
      )}
    </BaseLayout>
  );
}

ThreeColumn.defaultProps = {
  className: "",
  style: {},
  leftSectionStyle: {},
  rightSectionStyle: {},
  middleSectionStyle: {},
  isLeftFillSpace: false,
  isRightFillSpace: false,
  ismiddleFillSpace: false,
};

ThreeColumn.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  leftSectionStyle: PropTypes.object,
  rightSectionStyle: PropTypes.object,
  leftSection: PropTypes.node.isRequired,
  rightSection: PropTypes.node.isRequired,
  middleSection: PropTypes.node.isRequired,
  isLeftFillSpace: PropTypes.bool,
  isRightFillSpace: PropTypes.bool,
  ismiddleFillSpace: PropTypes.bool,
};

export default ThreeColumn;
